import type { MindMapNode } from "@/components/chat/mind-map/types";

interface RawNode {
  id: string;
  label: string;
  children?: RawNode[];
}

interface RawMindMap {
  title: string;
  root: string;
  nodes: RawNode[];
  description?: string;
}

function convertNode(raw: RawNode): MindMapNode {
  return {
    id: raw.id,
    label: raw.label,
    children: raw.children?.map(convertNode),
  };
}

export function parseMindMapBlock(
  jsonStr: string
): { title: string; data: MindMapNode; description?: string } | null {
  try {
    const raw: RawMindMap = JSON.parse(jsonStr);

    if (!raw.title || !raw.root || !Array.isArray(raw.nodes)) return null;

    const rootNode: MindMapNode = {
      id: "root",
      label: raw.root,
      children: raw.nodes.map(convertNode),
    };

    return {
      title: raw.title,
      data: rootNode,
      description: raw.description,
    };
  } catch {
    return null;
  }
}
